import { render, staticRenderFns } from "./totalDrive.vue?vue&type=template&id=667cc185&scoped=true&"
import script from "./totalDrive.vue?vue&type=script&lang=js&"
export * from "./totalDrive.vue?vue&type=script&lang=js&"
import style0 from "./totalDrive.vue?vue&type=style&index=0&id=667cc185&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667cc185",
  null
  
)

export default component.exports